<template>
    <div class="account_wallet__wrapper">
      <div class="back-btn__wrapper">
        <BackBtn @click="$router.back()"/>
      </div>
      <div class="account">
        <div class="currency">{{ selectedWallet.currency_code }}</div>
        <div class="amount">{{ getCurrencySymbol(selectedWallet.currency_code) }} {{ selectedWallet.balance }}</div>
      </div>
      <Payment />
      <TransactionsList :title="text('history.title')" />

<!--      <div class="account_details">-->
<!--        <h3>Данные счета</h3>-->
<!--        <div class="account_detail_block block_top">-->
<!--          <p>E-mail:</p>-->
<!--          <h6>Dmitrii@mail.ru</h6>-->
<!--        </div>-->
<!--        <div class="account_detail_block">-->
<!--          <p>Телефон</p>-->
<!--          <h6>+7 (963) 214-90-12</h6>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="walletId">-->
<!--        <div class="history_head">-->
<!--          <div class="title">История</div>-->
<!--          <DateRangePicker />-->
<!--        </div>-->
<!--        <div class="statistics">-->
<!--          <img class="statistics_img" src="@/assets/images/history_degree.png" alt="">-->
<!--          <img class="statistics_img statistics_img_mobile" src="@/assets/images/history_degree_mobile.png" alt="">-->
<!--        </div>-->
<!--        <div class="statistics_list">-->
<!--          <div v-for="(item, idx) in statistics_list" :key="idx" :class="`statistics_item ${item.class}`">-->
<!--            <div>-->
<!--              <div class="amount">{{item.amount}}</div>-->
<!--              <div class="contition">{{item.condition}}</div>-->
<!--            </div>-->
<!--            <div class="percent">{{item.percent}}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="main_line"></div>-->
<!--        <TransactionsList />-->
<!--      </div>-->
    </div>

</template>

<script>
import WalletList from "@/components/WalletList.vue"
import Payment from '@/components/Payment.vue'
import TransactionsList from '@/components/transactions/TransactionsList.vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import { getCurrencySymbol } from "@/utils/currency.js"
import BackBtn from "@/components/base/buttons/BackBtn.vue";

export default {
    name: "WalletId",
    components: {
        WalletList,
        Payment,
        TransactionsList,
        DateRangePicker,
        BackBtn
    },
    data () {
        return {
            statistics_list: [
                {amount: '$159.45', condition: 'Пополнения', percent: '62%', class: 'green'},
                {amount: '$74.62', condition: 'Выводы', percent: '12%', class: 'red'},
                {amount: '$29.32', condition: 'Платежи', percent: '20%', class: 'yellow'},
                {amount: '$5.00', condition: 'Прочее', percent: '6%', class: 'blue'},
            ],
            accounts: [
                {currency: 'RUB', amount: '₽ 21,860.02'},
            ],
            add_account_active: false,
        }
    },
    computed: {
      walletList () {
        return this.$store.state.walletList
      },
      selectedWallet({ walletList }) {
        const { id: walletId } = this.$route.params
        return walletList?.find(({ id }) => id === walletId) || {}
      }
    },
    created() {
      this.$store.dispatch('refreshWalletList');
    },
    methods: {
      getCurrencySymbol
    }
}
</script>

<style lang="css" scoped>
  .account_wallet__wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    margin-bottom: 180px;

    .account {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 16px;
      flex-direction: column;
      gap: 8px;
      border-radius: 16px;
      background: var(--accent-bg);
      box-shadow: 0 4px 25px 0 rgba(19, 1, 56, 0.07);

      .currency {
        padding: 4px 8px;
        border-radius: 4px;
        background: var(--main-color-3-b-363-f, #3B363F);
        color: #FFF;
        font-family: "Rubik", sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .amount {
        color: #262329;
        font-family: "Rubik", sans-serif;
        font-size: 30px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
      img {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
      }
    }
    .account_details {
      border-radius: 16px;
      background: var(--element-bg);
      padding: 16px;
      h3 {
        margin-bottom: 25px;
        color: var(--main-color-ffffff, #FFF);
        font-family: "Rubik", sans-serif;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.36px;
      }
      .block_top {
        margin-bottom: 20px;
      }
      .account_detail_block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          color: #A6A4B4;
          font-family: "Rubik", sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 135%;
        }
        h6 {
          color: #FFF;
          font-family: "Rubik", sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 135%;
        }
      }
    }

    .walletId {
      border-radius: 16px;
      background: var(--main-color-262329, #262329);

      .history_head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 25px;

        .title {
          color: #FFF;
          font-family: "Rubik", sans-serif;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          letter-spacing: 0.4px;
        }
        .time {
          display: flex;
          align-items: center;
          gap: 8px;

          span {
            color: #C7FF24;
            font-family: "Rubik", sans-serif;
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }
      }
      .payment {
        padding: 25px 0;
      }
      .statistics {
        display: flex;
        align-items: center;
        padding: 0;
        margin-bottom: 25px;
        justify-content: space-between;

        .statistics_img {
          width: 100%;
        }
        .statistics_img_mobile {
          display: none;
        }
      }
      .statistics_list {
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 25px;

        .statistics_item {
          width: calc(50% - 4px);
          border-radius: 8px;
          background: #3B363F;
          padding: 10px 8px 10px 12px;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          position: relative;
          overflow: hidden;

          .amount {
            color: #FFF;
            font-family: "Rubik", sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 135%;
            margin-bottom: 8px;
          }
          .contition {
            color: #A6A4B4;
            font-family: "Rubik", sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          .percent {
            color: #A6A4B4;
            font-family: "Rubik", sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 135%;
          }
          .green::before {
            background: #00BF8E;
          }
          .red::before {
            background: #F34B47;
          }
          .yellow::before {
            background: #F4B52B;
          }
          .blue::before {
            background: #2C4A9B;
          }
        }
        .statistics_item::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 3px;
          height: 100%;
        }
      }
      .transaction_wrapper {
        padding: 0;
        margin: 0;
        .title {
          display: none;
        }
      }
      .main_line {
        border-radius: 10px;
        background: #312C35;
        height: 1px;
        width: calc(100% - 48px);
        margin-bottom: 15px;
        margin-left: auto;
      }
    }

    @media (max-width: 920px) {
      .account_details {
        background: var(--layout-bg);
      }
      .walletId {
        padding: 16px;
      }
    }
  }
</style>